import { render, staticRenderFns } from "./InformationFooter.vue?vue&type=template&id=22d21dc4&scoped=true&"
var script = {}
import style0 from "./InformationFooter.vue?vue&type=style&index=0&id=22d21dc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d21dc4",
  null
  
)

export default component.exports